import { IConfig } from 'src/interfaces';
import http from './http';

class ConfigService {
  static patchConfig(data: Partial<IConfig>) {
    return http.patch('/configs', data);
  }

  static getConfig() {
    return http.get('/configs');
  }
}
export default ConfigService;
